import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  multiSelect: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.secondary,
  },
  gridItem: {
    height: '100%',
    justifyContent: 'space-between',
  },
  link: {
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  infoIcon: {
    cursor: 'help',
  },
}))

export default styles
